import { businessService } from '@/pages/Business/services/business.service';
import type {
  AmendmentTransition,
  ApplyAmendmentArgs,
  ApplyAmendmentResponse,
  Amendment,
  ReasonSuggestion,
} from '../models';
import type { PaginatedResponse } from '@/types';

const amendmentsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getAvailableAmendments: builder.query<AmendmentTransition[], number>({
      query: (shippingNumber) => ({
        url: `/amendments/${shippingNumber}/available`,
      }),
    }),

    applyAmendment: builder.mutation<ApplyAmendmentResponse, ApplyAmendmentArgs>({
      query: ({ shippingNumber, transitionId, reason, driverId }) => ({
        url: '/amendments/apply',
        method: 'POST',
        body: {
          shippingNumber,
          transitionId,
          reason,
          ...(driverId && { driverId }),
        },
      }),
      invalidatesTags: ['Amendments'],
    }),

    getReasonSuggestions: builder.query<ReasonSuggestion[], string>({
      query: (transitionId) => ({
        url: '/amendments/reason-suggestions',
        params: { transitionId },
      }),
    }),

    getAmendments: builder.query<
      PaginatedResponse<Amendment>,
      {
        shippingNumber?: string;
        transitionId?: string;
        from?: string;
        to?: string;
        limit?: number;
        offset?: number;
      }
    >({
      query: (params) => ({
        url: '/amendments',
        params: {
          ...(params.shippingNumber && { shippingNumber: params.shippingNumber }),
          ...(params.transitionId && { transitionId: params.transitionId }),
          ...(params.from && { from: params.from }),
          ...(params.to && { to: params.to }),
          limit: params.limit ?? 20,
          offset: params.offset ?? 0,
        },
      }),
      providesTags: ['Amendments'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAvailableAmendmentsQuery,
  useApplyAmendmentMutation,
  useGetReasonSuggestionsQuery,
  useGetAmendmentsQuery,
} = amendmentsApi;
